import { render, staticRenderFns } from "./InfoManage.vue?vue&type=template&id=79a6cd04&scoped=true&"
import script from "./InfoManage.vue?vue&type=script&lang=js&"
export * from "./InfoManage.vue?vue&type=script&lang=js&"
import style0 from "./InfoManage.vue?vue&type=style&index=0&id=79a6cd04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6cd04",
  null
  
)

export default component.exports